import React from "react";
import { Tetris } from "./Tetris";
import { registerGame } from "../common/registry";
import type { Game } from "../common/types";

const TetrisIcon: React.ReactNode = (
  <div className="flex h-full w-full flex-col items-center justify-center gap-0.5 p-2">
    <div className="h-3 w-3 rounded-sm bg-violet-400 shadow-[0_0_8px_rgba(167,139,250,0.8)] dark:bg-violet-300" />
    <div className="flex gap-0.5">
      <div className="h-3 w-3 rounded-sm bg-cyan-400 shadow-[0_0_8px_rgba(34,211,238,0.7)]" />
      <div className="h-3 w-3 rounded-sm bg-violet-500" />
      <div className="h-3 w-3 rounded-sm bg-amber-400 shadow-[0_0_8px_rgba(251,191,36,0.7)]" />
    </div>
  </div>
);

const tetrisGame: Game = {
  id: "tetris",
  name: "games.list.tetris.title",
  description: "games.list.tetris.description",
  component: Tetris,
  icon: TetrisIcon,
  category: "arcade",
};

registerGame(tetrisGame);

export { Tetris };
export default tetrisGame;
